import React from "react";
import "./ToggleOnOf.css";

const ToggleOnOf = ({ onClick, value }) => {
  return (
    <>
      <input
        type="checkbox"
        name="check-toggle"
        id="checkbox"
        hidden={true}
        checked={value}
        onChange={onClick}
      />
      <label htmlFor="checkbox" className="toggle">
        <label className={value ? "" : "color-font-toggle-active"}>Kg</label>
        <div className="toggle__switch">
          <div className="toggle__circle"></div>
        </div>
        <label className={value ? "color-font-toggle-active" : ""}>Pcs</label>
      </label>
    </>
  );
};

export default ToggleOnOf;
